module.exports = __webpack_public_path__ + "static/media/defaultLogo.bc6f04ed.png";